import React, { useState, useEffect, useRef } from 'react';
import { formatUsername } from '../utils/formatters';

const ConnectionStatus = ({ isConnected, uniqueUsername }) => {
  const [isStatusVisible, setIsStatusVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  
  const statusTimerRef = useRef(null);
  const fadeTimerRef = useRef(null);

  useEffect(() => {
    if (fadeTimerRef.current) {
      clearTimeout(fadeTimerRef.current);
      fadeTimerRef.current = null;
    }

    // Если isConnected === null, ничего не показываем
    if (isConnected === null) {
      setIsStatusVisible(false);
      setIsFadingOut(false);
      if (statusTimerRef.current) {
        clearTimeout(statusTimerRef.current);
        statusTimerRef.current = null;
      }
      if (fadeTimerRef.current) {
        clearTimeout(fadeTimerRef.current);
        fadeTimerRef.current = null;
      }
      return;
    }

    if (isConnected) {
      setIsStatusVisible(true);
      setIsFadingOut(false);

      if (statusTimerRef.current) {
        clearTimeout(statusTimerRef.current);
      }
      
      fadeTimerRef.current = setTimeout(() => {
        setIsFadingOut(true);
        fadeTimerRef.current = null;
      }, 3000);
      
      statusTimerRef.current = setTimeout(() => {
        setIsStatusVisible(false);
        setIsFadingOut(false);
        statusTimerRef.current = null;
      }, 4000);
    } else {
      if (statusTimerRef.current) {
        clearTimeout(statusTimerRef.current);
        statusTimerRef.current = null;
      }
      if (fadeTimerRef.current) {
        clearTimeout(fadeTimerRef.current);
        fadeTimerRef.current = null;
      }

      setIsStatusVisible(true);
      setIsFadingOut(false);
    }

    return () => {
      if (statusTimerRef.current) {
        clearTimeout(statusTimerRef.current);
        statusTimerRef.current = null;
      }
      if (fadeTimerRef.current) {
        clearTimeout(fadeTimerRef.current);
        fadeTimerRef.current = null;
      }
    };
  }, [isConnected]);

  if (!isStatusVisible) {
    return null;
  }

  return (
    <>
      {isConnected ? (
        <div className={`connection-status connected${isFadingOut ? ' fade-out' : ''}`}>
          ✅ Подключено
          {uniqueUsername && (
            <span>
              Ваше имя: {formatUsername(uniqueUsername)}
            </span>
          )}
        </div>
      ) : (
        <div className="connection-status">
          ❌ Соединение потеряно
          <span>
            Попробуйте перезагрузить страницу
          </span>
        </div>
      )}
    </>
  );
};

export default ConnectionStatus;
